import { getInit, type PollOptions } from './poll';

export type JobStatus = 'queued' | 'running' | 'done' | 'failed' | 'failed_terminal' | 'cancelled';

export interface Job {
  id: number;
  job_type: string;
  status: JobStatus;
  priority: number;
  payload: Record<string, unknown>;
  retry_count: number;
  last_error: string | null;
  correlation_id: string | null;
  created_at: string | null;
  started_at: string | null;
  finished_at: string | null;
  created_by_email: string | null;
}

export interface JobsPage {
  items: Job[];
  total: number;
  page: number;
  per_page: number;
  stats: Partial<Record<JobStatus, number>>;
}

export interface JobFilters {
  status?: JobStatus;
  job_type?: string;
  page?: number;
  per_page?: number;
}

export async function fetchJobs(filters: JobFilters = {}, opts: PollOptions = {}): Promise<JobsPage> {
  const params = new URLSearchParams();
  if (filters.status)   params.set('status', filters.status);
  if (filters.job_type) params.set('job_type', filters.job_type);
  if (filters.page)     params.set('page', String(filters.page));
  if (filters.per_page) params.set('per_page', String(filters.per_page));

  const res = await fetch(`/api/v1/jobs?${params}`, getInit(opts));
  if (!res.ok) throw new Error(`Jobs fetch failed: ${res.status}`);
  return res.json() as Promise<JobsPage>;
}
